// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Condition } from './Condition';
import {
  ConditionFromJSON,
  ConditionFromJSONTyped,
  ConditionToJSON,
  ConditionToJSONTyped,
} from './Condition';
import type { ClusterStatusObservation } from './ClusterStatusObservation';
import {
  ClusterStatusObservationFromJSON,
  ClusterStatusObservationFromJSONTyped,
  ClusterStatusObservationToJSON,
  ClusterStatusObservationToJSONTyped,
} from './ClusterStatusObservation';

/**
 *
 * @export
 * @interface ClusterStatus
 */
export interface ClusterStatus {
  /**
   *
   * @type {ClusterStatusObservation}
   * @memberof ClusterStatus
   */
  clusterStatus?: ClusterStatusObservation;
  /**
   *
   * @type {Array<Condition>}
   * @memberof ClusterStatus
   */
  conditions?: Array<Condition>;
}

/**
 * Check if a given object implements the ClusterStatus interface.
 */
export function instanceOfClusterStatus(value: object): value is ClusterStatus {
  return true;
}

export function ClusterStatusFromJSON(json: any): ClusterStatus {
  return ClusterStatusFromJSONTyped(json, false);
}

export function ClusterStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterStatus {
  if (json == null) {
    return json;
  }
  return {
    clusterStatus:
      json['cluster_status'] == null
        ? undefined
        : ClusterStatusObservationFromJSON(json['cluster_status']),
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionFromJSON),
  };
}

export function ClusterStatusToJSON(json: any): ClusterStatus {
  return ClusterStatusToJSONTyped(json, false);
}

export function ClusterStatusToJSONTyped(
  value?: ClusterStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cluster_status: ClusterStatusObservationToJSON(value['clusterStatus']),
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionToJSON),
  };
}
